<script>
import DialogBaseInput from './DialogBaseInput.vue'
export default {
    components: {
        DialogBaseInput
    },
    props: {
        name: String,
        type: {
            type: String,
            default: 'text'
        },
        placeholder: String,
        error: String,
        value: {}
    }
}
</script>

<template>
    <div class="DialogInput" >
        <p>{{name}}</p>
        <DialogBaseInput :type="type" :placeholder="placeholder" :error="error" :value="value" @input="$emit('input', $event)" />
    </div>
</template>

<style lang="scss" scoped>
.DialogInput {
    display: flex;
    >p {
        line-height: 36px;
        margin-right: 20px;
        text-align: right;
        width: 56px;
        color: #0A2136;
    }
    .DialogBaseInput {
        flex-grow: 1;
    }
}
</style>





// WEBPACK FOOTER //
// yotta-vue-components/vision/DialogInput.vue